import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classnames from 'classnames';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { track } from '@client/helpers';
import { buildCampaignUrl } from '@client/helpers/campaignUrl';
import { XMAS_EVENT_DELIVERY_PROMISE } from '@client/config/constants';
import CampaignLabel from '../CampaignLabel';
import { getSelectedFilter } from '@client/redux/modules/mylounge-legacy/selectors';
import { getTrackingData } from '@client/redux/modules/tracking/selectors';
import { getCampaignSublineCategory } from '@client/redux/modules/myloungeMetadata/selectors';

import styles from './openCampaign.scss';

export class OpenCampaign extends React.Component {
    render() {
        const {
            campaign,
            dimension,
            campaignStyles,
            showDelivery,
            imageUrl,
            minHeight,
            filterTag,
            sublineCategory,
        } = this.props;
        const campaignId = `campaign-${campaign.campaignIdentifier}`;

        const destination = buildCampaignUrl(campaign.campaignIdentifier, filterTag);
        const labelHeight = 60;
        const previewItemsLabelHeight = labelHeight + 35;

        // NOTE: quick hack, if the test succeeds, this will be removed and the components will be updated
        let deliveryLabel = null;
        if (campaign.options && campaign.options.deliveryPromiseType) {
            deliveryLabel = campaign.bannerSpecialText;
        }

        const coverWithoutLogo = !campaign.hasLogo;

        return (
            <div
                id={campaignId}
                styleName="wrapper"
                style={campaignStyles}
            >
                <div styleName="inner-wrapper" style={{ minHeight: minHeight + labelHeight }}>
                    <div style={{ minHeight: minHeight + previewItemsLabelHeight }}>
                        <a
                            onClick={this.trackingFunc()}
                            href={destination}
                            style={{ minHeight, backgroundImage: `url(${imageUrl})` }}
                            styleName={classnames('img', { 'without-logo': coverWithoutLogo })}
                        />
                        {coverWithoutLogo && (
                            <div styleName={classnames('title-label', { 'with-delivery': !!deliveryLabel })}>
                                {campaign.name}
                            </div>
                        )}
                        <div styleName="label">
                            <CampaignLabel
                                discount={campaign.discount.value}
                                dimension={dimension}
                                hover={false}
                                campaign={campaign}
                                showDelivery={showDelivery}
                                categorySubline={sublineCategory}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    trackingFunc = (extraVariables = {}) => () => {
        const { campaign, position, filterTag, tracking } = this.props;

        track('campaignOverview_campaign_click', {
            productCampaign: campaign.campaignIdentifier,
            positionNumber: position,
            campaign_level_2: filterTag,
            campaign_level_1: campaign.name,
            visitorID: tracking ? tracking.visitorID : null,
            ...(campaign.options && campaign.options.deliveryPromiseType === XMAS_EVENT_DELIVERY_PROMISE && { component: 'christmas' }),
            ...extraVariables,
        });
    }
}

OpenCampaign.propTypes = {
    campaign: PropTypes.object.isRequired,
    dimension: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired,
    campaignStyles: PropTypes.object,
    showDelivery: PropTypes.bool,
    imageUrl: PropTypes.string,
    minHeight: PropTypes.string,
    filterTag: PropTypes.string,
    sublineCategory: PropTypes.arrayOf(PropTypes.string),
    tracking: PropTypes.object
};

const mapStateToProps = (state, ownProps) => ({
    filterTag: getSelectedFilter(state),
    tracking: getTrackingData(state),
    sublineCategory: getCampaignSublineCategory(state, ownProps.campaign.campaignIdentifier),
});

export default compose(
    connect(mapStateToProps),
    CSSModules(styles, { allowMultiple: true })
)(OpenCampaign);
